import { createReducer } from '@reduxjs/toolkit'

import type { TDashboardFolderDto } from '@homepal/api-contract'

import * as actions from '../../actions/DashboardFolders/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

import { insertItems, upsertItem, removeItem } from 'redux/utils'

export type DashboardFolderStore = {
  data: { [key: string]: TDashboardFolderDto }
  fetched: boolean
  isCreating: boolean
  isDeleting: boolean
  isUpdating: boolean
}

// Initial state
const INITIAL_STATE: DashboardFolderStore = {
  data: {},
  fetched: false,
  isCreating: false,
  isDeleting: false,
  isUpdating: false
}

// Reducer
const DashboardFolderReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.create, (state) => {
      state.isCreating = true
    })
    .addCase(actions.createSuccess, (state, action) => {
      state.isCreating = false
      state.data = upsertItem(state.data, action.payload)
    })
    .addCase(actions.createFailed, (state) => {
      state.isCreating = false
    })
    .addCase(actions.getAllSuccess, (state, action) => {
      state.fetched = true
      state.data = insertItems(action.payload)
    })
    .addCase(actions.update, (state) => {
      state.isUpdating = true
    })
    .addCase(actions.updateSuccess, (state, action) => {
      state.isUpdating = false
      state.data = upsertItem(state.data, action.payload)
    })
    .addCase(actions.updateFailed, (state) => {
      state.isUpdating = false
    })
    .addCase(actions.destroy, (state) => {
      state.isDeleting = true
    })
    .addCase(actions.destroySuccess, (state, action) => {
      state.isDeleting = false
      state.data = removeItem(state.data, action.payload)
    })
    .addCase(actions.destroyFailed, (state) => {
      state.isDeleting = false
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})

export default DashboardFolderReducer
